module.exports = __webpack_public_path__ + "img/user-placeholder.e806f9e8.svg";